import EZ2D from '../assets/images/PCSOEZ2LG.png';
import PICK3 from '../assets/images/PCSOPICK3LG.png';
import SWERTRES from '../assets/images/PCSOSLG.png';
import LAST3 from '../assets/images/PCSOLAST3.png';

const toCurrency = (value, decimal = 2) => {
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  });
  return formatter.format(+value || 0);
};

const getUser = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return user?.user;
};

const userRoleName = (roleId) => {
  switch (roleId) {
    case 1:
      return 'Admin';
    case 2:
      return 'Incorporator';
    case 3:
      return 'Sub Operator';
    case 4:
      return 'General Coordinator';
    case 5:
      return 'Coordinator';
    case 6:
      return 'Sub Coordinator';
    case 7:
      return 'Agent';
    case 8:
      return 'Sub Agent';
    default:
      return 'Player';
  }
};

const roles =
  import.meta.env.VITE_BUILD_NAME !== 'elotto'
    ? [
        {
          id: 2,
          name: 'Incorporator',
        },
        {
          id: 3,
          name: 'Sub Operator',
        },
        {
          id: 4,
          name: 'General Coordinator',
        },
        {
          id: 5,
          name: 'Coordinator',
        },
        {
          id: 6,
          name: 'Sub Coordinator',
        },
        {
          id: 7,
          name: 'Agent',
        },
        {
          id: 8,
          name: 'Sub Agent',
        },
        {
          id: 9,
          name: 'Player',
        },
      ]
    : [
        {
          id: 2,
          name: 'General Coordinator',
        },
        {
          id: 3,
          name: 'Coordinator',
        },
        {
          id: 4,
          name: 'Agent',
        },
        {
          id: 5,
          name: 'Player',
        },
      ];

const downloadPdf = () => {
  var style = document.createElement('style');
  style.innerHTML = `
    @media print {
      @page {
        size: landscape;
      }
      div:has(table) {
        overflow: visible !important;
        position: relative;
        width: 100%;
        height: 100%;
      }
    }
    `;
  document.head.appendChild(style);
  setTimeout(() => {
    window.print();
  }, 10);
};

const getGameTicketImage = (gameId) => {
  switch (gameId) {
    case 1:
      return SWERTRES;
    case 5:
    case 2:
      return EZ2D;
    case 3:
      return PICK3;
    case 4:
      return EZ2D;
    case 8:
      return LAST3;
    default:
      return SWERTRES;
  }
};

export {
  toCurrency,
  getUser,
  userRoleName,
  roles,
  downloadPdf,
  getGameTicketImage,
};
